import lodash from "lodash";
import { ParameterTypesResponse } from "@/main/models/response/parameterTypesResponse";

export function handleValueParameterType(
	idParameterTypeRow: number,
	id: string,
	newValue: string | null,
	dataParameterTypes: ParameterTypesResponse[],
): ParameterTypesResponse[] {
	const cloneDataParameterTypes = lodash.cloneDeep(dataParameterTypes);
	const parameterTypeIndex = cloneDataParameterTypes.findIndex((x) => x.idParameterType === idParameterTypeRow);
	if (parameterTypeIndex === -1) return dataParameterTypes;

	const parameterIndex = cloneDataParameterTypes[parameterTypeIndex].parameters.findIndex((x) => x.guid === id);
	if (parameterIndex === -1) return dataParameterTypes;

	cloneDataParameterTypes[parameterTypeIndex].parameters[parameterIndex].value = newValue === "" ? null : newValue;
	return cloneDataParameterTypes;
}

export function checkParametersChange(
	dataParameterTypes: ParameterTypesResponse[],
	parameterTypes: ParameterTypesResponse[],
) {
	for (let index = 0; index < dataParameterTypes.length; index++) {
		if (dataParameterTypes[index].idParameterType === parameterTypes[index].idParameterType) {
			for (let x = 0; x < dataParameterTypes[index].parameters.length; x++) {
				if (
					dataParameterTypes[index].parameters[x].guid !== parameterTypes[index].parameters[x].guid ||
					dataParameterTypes[index].parameters[x].value !== parameterTypes[index].parameters[x].value
				) {
					return true;
				}
			}
		} else {
			return true;
		}
	}
	return false;
}
